<template>
  <div v-if="dataPermission.includes('SCON_RECEIPT_AGENCY_VIEW')">
    <div class="p-3">
      <div class="breadcrumb-area pos-relative w-100">
        <h1>Chi tiết phiếu thu đại lý</h1>
        <div class="btn-group float-right">
          <button
            type="button"
            class="font-medium btn btn-outline-secondary"
            @click="$router.push('/agent-receipt')"
          >
            <i class="bx bx-exit"></i> Quay lại
          </button>
          <button
            v-if="item?.status === 'NEW'"
            class="btn font-medium btn-outline-secondary"
            @click="
              item?.source === 'NEXT_AGENT'
                ? $router.push(`/agent-receipt-oder-form-edit/${item.id}`)
                : $router.push(`/agent-receipt-edit/${item.id}`)
            "
          >
            <i class="bx bx-edit"></i><span>&nbsp;</span>Cập nhật
          </button>
          <button
            v-if="item?.status === 'NEW'"
            class="btn font-medium btn-outline-secondary"
            @click="approvePending(item)"
          >
            <i class="bx bx-check-circle"></i><span>&nbsp;</span>Chuyển chờ duyệt
          </button>
          <button
            class="btn font-medium btn-outline-secondary"
            v-if="item?.status === 'PENDING_ACCOUNTANT_APPROVAL'"
            @click="approveItem(item)"
          >
            <i class="bx bx-check-circle"></i><span>&nbsp;</span>Duyệt
          </button>
          <button
            class="btn font-medium btn-outline-secondary"
            v-if="
              item?.status === 'PENDING_SA_APPROVAL' &&
              dataPermission.includes('SCON_RECEIPT_AGENCY_SALE_ADMIN_ACTION')
            "
            @click="approveItemSA(item)"
          >
            <i class="bx bx-check-circle"></i><span>&nbsp;</span>Duyệt
          </button>
          <button
            class="btn font-medium btn-outline-secondary"
            v-if="
              item?.status === 'PENDING_SA_APPROVAL' &&
              dataPermission.includes('SCON_RECEIPT_AGENCY_SALE_ADMIN_ACTION')
            "
            @click="rejectItemSA(item)"
          >
            <i class="bx bx-x-circle"></i><span>&nbsp;</span>Từ chối
          </button>
          <button
            class="btn font-medium btn-outline-secondary"
            v-if="
              item?.status === 'PENDING_ACCOUNTANT_APPROVAL' &&
              dataPermission.includes('SCON_RECEIPT_AGENCY_ACCOUNTANT_ACTION')
            "
            @click="rejectItem(item)"
          >
            <i class="bx bx-x-circle"></i><span>&nbsp;</span>Từ chối
          </button>
          <button
            class="btn font-medium btn-outline-secondary"
            v-if="item?.status === 'NEW'"
            @click="approveCencelItem(item)"
          >
            <i class="bx bx-x-circle"></i><span>&nbsp;</span>Huỷ
          </button>
          <button
            class="btn font-medium btn-outline-secondary"
            v-if="item?.status === 'PENDING_ACCOUNTANT_APPROVAL'"
            @click="editReceiptCode(item)"
          >
            <i class="bx bx-edit"></i><span>&nbsp;</span>Sửa mã giao dịch
          </button>

          <button
            v-if="
              dataPermission.includes('SCON_RECEIPT_AGENCY_CHANGE_STT_INVOICE') &&
              item?.invoiceState === 'NEW'
            "
            class="btn font-medium btn-outline-secondary"
            @click="
              approveItemAgent(item, 'MANUAL', 'Bạn có chắc chắn xác nhận tạo hoá đơn thủ cộng')
            "
          >
            Đã tạo hoá đơn thủ công
          </button>
          <button
            v-if="
              dataPermission.includes('SCON_RECEIPT_AGENCY_CHANGE_STT_INVOICE') &&
              item?.invoiceState === 'CANCEL'
            "
            class="btn font-medium btn-outline-secondary"
            @click="approveItemAgent(item, 'NEW', 'Bạn có chắc chắn xác nhận chưa tạo hoá đơn')"
          >
            Chưa tạo hoá đơn
          </button>
          <button
            v-if="
              dataPermission.includes('SCON_RECEIPT_AGENCY_CHANGE_STT_INVOICE') &&
              (item?.invoiceState === 'NEW' ||
                item?.invoiceState === 'AUTO' ||
                item?.invoiceState === 'MANUAL')
            "
            class="btn font-medium btn-outline-secondary"
            @click="approveItemAgent(item, 'CANCEL', 'Bạn có chắc chắn xác nhận huỷ hoá đơn')"
          >
            Đã huỷ hoá đơn
          </button>
          <button
            v-if="dataPermission.includes('SCON_RECEIPT_AGENCY_UPDATE_BY_SALE_ADMIN')"
            class="btn font-medium btn-outline-secondary"
            @click="openSupplementModal"
          >
            <i class="bx bx-plus-circle"></i><span>&nbsp;</span>Bổ sung thông tin
          </button>
        </div>
      </div>
      <div class="card p-10 pt-15 b-t-1-869fb229">
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-detail">
              <h1 class="form-inner-heading mb-1">Thông tin chung</h1>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Mã phiếu thu <span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item?.receiptCode }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Người tạo<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12 text-primary" type="button">
                    {{ item?.createdByEmail }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Thời gian tạo<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12 text-primary" type="button">
                    {{ item?.createdDate | formatDate('HH:mm DD/MM/YYYY') }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Thời gian cập nhật<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12 text-primary" type="button">
                    {{ item?.modifiedDate | formatDate('HH:mm DD/MM/YYYY') }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Trạng thái<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    <span
                      class="badge"
                      :class="`badge-${transformColor(item?.status, dataStatus)}`"
                    >
                      {{ item?.status | transformData(dataStatus) }}
                    </span>
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Trạng thái xuất hoá đơn<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    <span
                      class="badge"
                      :class="`badge-${transformColor(item?.invoiceSate || item?.invoiceState, statusInvoice)}`"
                    >
                      {{ item?.invoiceSate || item?.invoiceState | transformData(statusInvoice) }}
                    </span>
                  </p>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Lý do từ chối<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item?.rejectReason }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row border-top mt-3 pt-3">
                <label for="" class="col-sm-4 col-form-label">
                  Tên Đại lý<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item?.agencyName }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Email<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item?.email }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Địa chỉ<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item?.address }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Số tiền<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item?.amount.toLocaleString('vi-VN') }} VNĐ
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Ngày thu tiền<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ formatTimestamp(item?.receiptDate) }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Mã phụ lục<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item?.appendixCode }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row" v-if="item?.purchaseOrderCode">
                <label for="" class="col-sm-4 col-form-label">
                  Phiếu đặt hàng<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    <a
                      :href="`/order-form-detail/${item?.purchaseOrderCode}?type=code`"
                      target="_blank"
                      class="text-primary"
                      style="cursor: pointer; text-decoration: underline"
                    >
                      {{ item?.purchaseOrderCode }}
                    </a>
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Mã giao dịch<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item?.transactionCode }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Ghi chú<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item?.description }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-detail" style="min-height: 425px">
              <div class="appendix-files-container">
                <h3 class="appendix-title">File phụ lục</h3>
                <div v-if="item?.appendixFiles?.length > 0" class="appendix-files-list">
                  <div
                    v-for="(fileLink, index) in item.appendixFiles"
                    :key="index"
                    class="appendix-file-item"
                  >
                    <div class="file-icon">
                      <i class="bx bxs-file-pdf"></i>
                    </div>
                    <div class="file-info">
                      <span class="file-label">File phụ lục #{{ index + 1 }}</span>
                    </div>
                    <a
                      :href="fileLink"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="view-file-btn"
                    >
                      <i class="fas fa-external-link-alt"></i> Xem tài liệu
                    </a>
                  </div>
                </div>
              </div>
              <div v-if="item?.uploadImgs?.length > 0">
                <UploadOneOrMultip
                  :title="'Ảnh chuyển khoản'"
                  :maxFile="100"
                  titleTag="h2"
                  :disabled="true"
                  :uploadToApi="false"
                  :isDragging="true"
                  titleClass="form-inner-heading"
                  ref="uploadComponent"
                />
              </div>
              <h3 style="font-weight: 600; font-size: 18px; padding-bottom: 10px" v-else>
                Ảnh chuyển khoản
              </h3>
            </div>
          </div>
        </div>
        <div class="card pt-2 p-10">
          <div class="d-flex pos-relative w-100 justify-content-between mb-2">
            <h1 class="form-inner-heading mb-1">Đơn giá</h1>
          </div>
          <div class="box-header">
            Tổng:
            <strong class="text-primary">{{ item?.products?.length || 0 }}</strong>
          </div>
          <div class="tab-content">
            <div
              class="table-responsive b-table-sticky-header"
              style="overflow: auto; max-height: 70vh"
            >
              <div class="table-responsive">
                <table
                  class="table table-hover table-bordered"
                  style="max-height: 400px; overflow-y: auto"
                >
                  <thead class="thead-light">
                    <tr>
                      <th>STT</th>
                      <th>Tên thiết bị</th>
                      <th>Số lượng</th>
                      <th>Đơn giá</th>
                      <th>Tổng</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="table-row" v-for="(s, index) in item?.products || []" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ s?.name }}</td>
                      <td>{{ s?.quantity }}</td>
                      <td>{{ s?.price?.toLocaleString('vi-VN') }}đ</td>
                      <td>{{ s?.amount?.toLocaleString('vi-VN') }}đ</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="card pt-2 p-10">
          <div class="d-flex pos-relative w-100 justify-content-between mb-2">
            <h1 class="form-inner-heading mb-1">Danh sách thiết bị</h1>
          </div>
          <div class="box-header">
            Tổng:
            <strong class="text-primary">{{ item?.devices?.length || 0 }}</strong>
          </div>
          <div class="tab-content">
            <div
              class="table-responsive b-table-sticky-header"
              style="overflow: auto; max-height: 70vh"
            >
              <div class="table-responsive">
                <table
                  class="table table-hover table-bordered"
                  style="max-height: 400px; overflow-y: auto"
                >
                  <thead class="thead-light">
                    <tr>
                      <th>STT</th>
                      <th>Tên thiết bị</th>
                      <th>Mã Serial</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="table-row" v-for="(s, index) in item?.devices || []" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ s?.name }}</td>
                      <td>{{ s?.serial }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="notiModal">
        <transition name="modal">
          <div class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      @click="notiModal = false"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body text-center">
                    <img :src="iconNoti" alt="icon-successs" />
                    <h2 class="f18 py-3">{{ msgNoti }}</h2>
                  </div>
                  <div class="modal-footer">
                    <!-- <button type="button" class="btn btn-primary" @click="checkToActionModal(keyCheck)"
                      data-dismiss="modal" v-if="
                        keyCheck === 'accept' ||
                        keyCheck === 'back' ||
                        keyCheck === 'addLead'
                      ">
                      Đồng ý
                    </button> -->
                    <button
                      type="button"
                      class="btn btn-light"
                      @click="notiModal = false"
                      data-dismiss="modal"
                    >
                      Đóng
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <b-modal centered static hide-footer hide-header size="xl" id="historyDetail">
      <detail-approve
        v-if="devicesHistory"
        :devices="devicesHistory"
        :item="item"
        :warehouseData="warehouseData"
      ></detail-approve>
    </b-modal>

    <b-modal id="cancel-moving" centered v-model="cancelMovingCancel">
      <template #modal-header="{ close }">
        <h5>Lý do từ chối</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          @click="close(), (reasonReject = '')"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <ValidationObserver>
        <ValidationProvider rules="required|minMaxName_1" vid="reasonReject" name="Lý do từ chối">
          <div slot-scope="{ errors }">
            <div class="text-center m-2">
              <input v-model="reasonReject" />
              <p class="text-danger">{{ errors[0] }}</p>
            </div>
          </div>
        </ValidationProvider>
      </ValidationObserver>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel(), (reasonReject = '')"> Đóng </b-button>
        <b-button
          variant="primary"
          @click="cancelMoving(item, reasonReject), (cancelMovingCancel = false)"
          :disabled="reasonReject == ''"
        >
          Đồng ý
        </b-button>
      </template>
    </b-modal>
    <SupplementInfoModal
      ref="supplementModal"
      :receiptId="item?.id"
      @supplement-success="onSupplementSuccess"
      @show-success="showSuccess"
      @show-error="showErr"
    />
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import UploadOneOrMultip from '@/components/cskh/UploadOneOrMultip.vue'
  import SupplementInfoModal from './SupplementInfoModal.vue' // Thêm dòng này

  import { mapGetters } from 'vuex'
  import { DeviceService } from '@/services/device.service'
  import Config from '@/thirdParty/config'
  import mxItemAction from './mx-item-action.js'
  import { nextTick } from 'vue'

  export default {
    mixins: [mxItemAction],
    components: { UploadOneOrMultip, SupplementInfoModal },
    data() {
      return {
        devicesHistory: null,
        item: null,
        entryId: this.$route.params.entryId,
        dataStatus: [...Config.statusTranferAgent],
        statusInvoice: Config.statusTranferAgentInvoice,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        loading: false,
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        Config,
        warehouseData: [],
        cancelMovingCancel: false,
        reasonReject: '',
      }
    },
    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig?.find(e => e.id === data) ?? {}
        return dataReturn.text
      },
    },
    created() {
      this.fetchData()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    methods: {
      openSupplementModal() {
        this.$refs.supplementModal.show()
      },

      onSupplementSuccess() {
        this.fetchData()
      },
      formatTimestamp(timestamp) {
        const date = new Date(timestamp)
        const day = String(date.getUTCDate()).padStart(2, '0')
        const month = String(date.getUTCMonth() + 1).padStart(2, '0')
        const year = date.getUTCFullYear()
        return `${day}/${month}/${year}`
      },
      transformColor(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].color
      },
      async fetchData() {
        try {
          this.loading = true
          const response = await DeviceService.detailTransferAgencyNew(this.entryId)

          if (response.code === 1000) {
            this.item = response.data
            const formattedImages = response.data.uploadImgs.map(imgUrl => ({
              url: imgUrl,
              location: 'website',
              type: 'images',
              uploaded: true,
            }))

            nextTick(() => {
              this.$refs.uploadComponent.setData(formattedImages)
            })
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },

      showErr(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
        this.msgNoti = message
      },
      showSuccess(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-success2.svg')
        this.msgNoti = message
      },
      getPersonAction(status) {
        if (status === 'APPROVED') return 'duyệt'
        if (status === 'REJECTED') return 'từ chối'
        return 'huỷ'
      },
    },
  }
</script>

<style scoped lang="scss">
  .appendix-files-container {
    /* background-color: #f8f9fa;
  border-radius: 10px;
  padding: 20px;

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); */
    margin: 20px 0;
  }

  .appendix-title {
    color: #333;
    font-size: 18px;
    margin-top: 0;
    margin-bottom: 16px;
    font-weight: 600;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
  }

  .appendix-files-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .appendix-file-item {
    display: flex;
    align-items: center;
    background-color: white;
    border-radius: 8px;
    padding: 14px 16px;
    transition: all 0.2s ease;
    border: 1px solid #e0e0e0;
  }

  .appendix-file-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border-color: #d0d0d0;
  }

  .file-icon {
    font-size: 22px;
    color: #2b7dd5;
    /* Màu đỏ cho file PDF */
    margin-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: rgba(171, 191, 243, 0.1);
    border-radius: 8px;
  }

  .file-info {
    flex-grow: 1;
  }

  .file-label {
    font-size: 15px;
    color: #444;
    font-weight: 500;
  }

  .view-file-btn {
    display: inline-flex;
    align-items: center;
    padding: 8px 16px;
    /* background-color: #3498db; */
    /* color: white; */
    border-radius: 6px;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    transition: background-color 0.2s;
    white-space: nowrap;
  }

  /* .view-file-btn:hover {
  background-color: #2980b9;
} */

  .view-file-btn i {
    margin-right: 8px;
  }
</style>
